const prefetchPage = (route) => ___loader?.hovering?.(route);

export const onRouteUpdate = ({ location }, { routes = [] }) => {
  const index = routes.findIndex((route) => route === location.pathname);
  const nextPage = index > -1 && routes[index + 1];

  nextPage && prefetchPage(nextPage);
};
